import type { AnyAction } from 'redux';
import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import { baseReducer } from '../../core/base-reducer';
import { calculatePagingStats, FIRST_PAGE, PAGE_SIZE_50 } from '../../../services/pagination-service';

import * as Actions from './ltl.grid.actions';

const initialPagingStats = calculatePagingStats(FIRST_PAGE, PAGE_SIZE_50, 0);

const initialState = {
  currentPageShipmentIds: emptyArray,
  selectedShipmentIds: emptyArray,
  ...initialPagingStats,
  isLoading: false,
  statusFilter: null as string | null,
  activeFilters: emptyObject as Record<string, unknown>,
};

export type GridState = typeof initialState;

const actionHandlerMap: Record<string, (state: GridState, action: AnyAction) => GridState> = {
  [Actions.GET_FREIGHT_GRID_REQUEST]: (state, action) => ({
    ...state,
    isLoading: true,
    selectedShipmentIds: emptyArray,
    page: action.page ?? state.page,
    pageSize: action.pageSize ?? state.pageSize,
    statusFilter: action.statusFilter !== undefined ? action.statusFilter : state.statusFilter,
  }),
  [Actions.GET_FREIGHT_GRID_SUCCESS]: (state, action) => ({
    ...state,
    isLoading: false,
    currentPageShipmentIds: action.currentPageShipmentIds,
    ...calculatePagingStats(action.page, action.pageSize, action.totalCount),
  }),
  [Actions.GET_FREIGHT_GRID_ERROR]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [Actions.SET_SELECTED_FREIGHT_SHIPMENT_IDS]: (state, action) => ({
    ...state,
    selectedShipmentIds: action.selectedShipmentIds,
  }),
  [Actions.SET_FREIGHT_GRID_FILTERS]: (state, action) => ({
    ...state,
    activeFilters: action.filters || emptyObject,
  }),
};

export const ConnectedActionHandlerMap = baseReducer(initialState, actionHandlerMap);
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { namespace } from './ltl.grid.reducer.metadata';
